import { useBreakpointValue } from '@wegroup/design-system';
import { useEffect, useState, Dispatch, SetStateAction } from 'react';
import { AppShellId } from '../../../../../../design-system/src/content/components/AppShell';
import { AdvisoryFlowMainContainerId } from '../components/app-shell/AdvisoryFlowMainContainer';

interface HandleButtonScroll {
  scrollContainer: HTMLDivElement;
  isScrollable: boolean;
  setIsScrollable: Dispatch<SetStateAction<boolean>>;
}

/**
 * This hook handles the logic behind the scroll button. This hook
 * should only be used inside the advisory-flow UI
 */
const useHandleButtonScroll = (): HandleButtonScroll => {
  const scrollContainerId = useBreakpointValue({
    base: AppShellId,
    laptop: AdvisoryFlowMainContainerId,
  });
  const scrollContainer = document.getElementById(
    scrollContainerId || AppShellId,
  ) as HTMLDivElement;

  const [isScrollable, setIsScrollable] = useState<boolean>(false);

  const handleScroll = () => {
    /**
     * This function will check if the scrollcontainer is scrolled all the way to the bottom
     */
    const offsetBottom = 24;
    if (
      scrollContainer &&
      scrollContainer.offsetHeight + scrollContainer.scrollTop >=
        scrollContainer.scrollHeight - offsetBottom
    ) {
      setIsScrollable(false);
    } else {
      setIsScrollable(true);
    }
  };

  useEffect(() => {
    scrollContainer?.addEventListener('scroll', handleScroll);
    window.addEventListener('resize', handleScroll);

    return () => {
      scrollContainer?.removeEventListener('scroll', handleScroll);
      window.addEventListener('resize', handleScroll);
    };
  }, [scrollContainer]);

  return { scrollContainer, isScrollable, setIsScrollable };
};

export default useHandleButtonScroll;
